import React, {} from 'react'
import ImageSwiper from './ImageSwiper';
import css from './ListingCardBox.module.css';
import { useConfiguration } from '../../context/configurationContext';
import { displayPrice } from '../../util/configHelpers';
import { isBookingProcessAlias } from '../../transactions/transaction';
import { formatMoney } from '../../util/currency';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { AvatarSmall, NamedLink, InlineTextButton } from '../../components';
import { createSlug, LISTING_PAGE_PARAM_TYPE_DRAFT } from '../../util/urlHelpers';
import { ensureListing } from '../../util/data';

const ListingCardBox = ({ listing, intl, reviews, toggleFavorites, profilePage }) => {
  const config = useConfiguration();
  const currentListing = ensureListing(listing);

  const { attributes = {}, author, images = [] } = currentListing || {};
  const { title = '', price, publicData = {} } = attributes;
  const id = currentListing?.id?.uuid || '';
  const slug = createSlug(title);

 const listingReview = reviews?.filter(review => {
    const reviewListingId = review?.listing?.id?.uuid;
    return reviewListingId === currentListing?.id?.uuid;
  }) || [];

  const averageRating = listingReview.length > 0
    ? listingReview.reduce((sum, r) => {
        const rating = r?.attributes?.rating || 0;
        return sum + rating;
      }, 0) / listingReview.length
    : null;

  // Price formatter
  const priceData = (price, currency, intl) => {
    if (price && price.currency === currency) {
      const formattedPrice = formatMoney(intl, price);
      return { formattedPrice, priceTitle: formattedPrice };
    } else if (price) {
      return {
        formattedPrice: intl.formatMessage(
          { id: 'ListingCard.unsupportedPrice' },
          { currency: price.currency }
        ),
        priceTitle: intl.formatMessage(
          { id: 'ListingCard.unsupportedPriceTitle' },
          { currency: price.currency }
        ),
      };
    }
    return {};
  };

  // Renders price if allowed
  const PriceMaybe = ({ price, publicData, config, intl }) => {
    const { listingType } = publicData || {};
    const validListingTypes = config.listing.listingTypes;
    const foundConfig = validListingTypes.find(conf => conf.listingType === listingType);
    const showPrice = displayPrice(foundConfig);

    if (!showPrice || !price) return null;

    const { formattedPrice, priceTitle } = priceData(price, config.currency, intl);
    return (
      <div className={css.price}>
        <div className={css.priceValue} title={priceTitle}>
          {formattedPrice} / night
        </div>
      </div>
    );
  };

  return (
    <div className={css.cardBox} data="cardBox">
      <div className={css.cardImgBox} data="cardImgBox">
        {/*publicData?.guests_favorite &&
          <NamedLink
            name="ProfilePage"
            params={{ id: author?.id?.uuid }}
            className={css.chooseFvrt}
            title="chooseFvrt"
            // onClick={() => toggleFavorites(currentListing?.id)}
          >
            Guests Favorite
          </NamedLink>
        */}
        <div className={css.imgBox}>
          <ImageSwiper images={images} id={id} slug={slug} />
        </div>
      </div>
      <div className={css.cardDetails} data="cardDetails">
        <div className={css.titleRow} data="titleRow">
          <div className={css.title} data="title">{title}</div>
          {averageRating !== null && !isNaN(averageRating) ? (
            <div className={css.ratingText}>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                <path d="M7.5 0L9.18386 5.18237H14.6329L10.2245 8.38525L11.9084 13.5676L7.5 10.3647L3.09161 13.5676L4.77547 8.38525L0.367076 5.18237H5.81614L7.5 0Z" fill="#8C8C8C"/>
              </svg>
              <span>{averageRating.toFixed(1)}</span>
            </div>
          ) : null}
        </div>
        <div className={css.userRow} data="userRow">
          <AvatarSmall user={author} className={css.userImage} />
          <NamedLink
            className={css.userProfileLink}
            name="ListingPage"
            params={{ id, slug }}
          >
            Hosted By - {author?.attributes?.profile?.displayName}
          </NamedLink>
        </div>

        <div className={css.cardPrice} data="cardPrice">
          <PriceMaybe price={price} publicData={publicData} config={config} intl={intl} />
        </div>
        <div className={css.cardFeatureRow} data="cardFeatureRow">
          <div className={css.featureBox}>Guests: <span className={css.num}>{publicData?.guest}</span></div>
          <div className={css.featureBox}>Rooms: <span className={css.num}>{publicData?.rooms}</span></div>
        </div>

        {!profilePage && 
          <NamedLink
            className={css.editListing}
            title="editListing"
            name="EditListingPage"
            params={{ id, slug, type: LISTING_PAGE_PARAM_TYPE_DRAFT, tab: 'details' }}
          >
              Edit your listing
          </NamedLink>
        }
      </div>
    </div>
  );
};

export default ListingCardBox;